const skills = [
  {
    id: 1,
    name: 'HTML',
    years: 4,
  },
  {
    id: 2,
    name: 'CSS',
    years: 4,
  },
  {
    id: 3,
    name: 'JavaScript',
    years: 4,
  },
  {
    id: 4,
    name: 'Accessibility',
    years: 4,
  },
  {
    id: 5,
    name: 'React',
    years: 3,
  },
  {
    id: 6,
    name: 'Sass',
    years: 3,
  },
];

export default skills;
